// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1CbWY","form":"styles_form__2TCSq"};